<script setup lang="ts">
import router from "@/router/router";
import { useAuthStore } from "@/store/authstore";
import { computed } from "vue";

const authStore = useAuthStore();
const initials = computed(() => authStore.user?.name?.charAt(0)?.toUpperCase() ?? "?");

async function handleLogout() {
  await authStore.logout();
  router.push("/login");
}
</script>

<template>
  <div class="user-menu-wrap">
    <v-menu location="bottom end" :offset="8">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          variant="text"
          rounded="lg"
          class="user-btn"
          append-icon="mdi-chevron-down"
        >
          <div class="user-avatar">{{ initials }}</div>
          <span class="user-name">{{ authStore.user?.name }}</span>
        </v-btn>
      </template>

      <div class="user-dropdown">
        <div class="dropdown-user-info">
          <div class="dropdown-avatar">{{ initials }}</div>
          <div>
            <div class="dropdown-name">{{ authStore.user?.name }}</div>
            <div class="dropdown-email">{{ authStore.user?.email }}</div>
          </div>
        </div>

        <div class="dropdown-divider" />

        <button class="dropdown-item" @click="router.push('/home')">
          <v-icon size="17">mdi-view-dashboard-outline</v-icon>
          <span>Oversigt</span>
        </button>
        <button class="dropdown-item" @click="router.push('/invoices')">
          <v-icon size="17">mdi-file-document-multiple-outline</v-icon>
          <span>Fakturaer</span>
        </button>
        <button class="dropdown-item" @click="router.push('/expenses')">
          <v-icon size="17">mdi-cart-outline</v-icon>
          <span>Køb</span>
        </button>
        <button class="dropdown-item" @click="router.push('/settings')">
          <v-icon size="17">mdi-cog-outline</v-icon>
          <span>Indstillinger</span>
        </button>

        <div class="dropdown-divider" />

        <button class="dropdown-item dropdown-item--danger" @click="handleLogout">
          <v-icon size="17">mdi-logout</v-icon>
          <span>Log ud</span>
        </button>
      </div>
    </v-menu>
  </div>
</template>

<style scoped>
.user-menu-wrap {
  display: flex;
  align-items: center;
}
.user-btn {
  color: #1e293b !important;
  gap: 10px;
  padding-left: 6px !important;
}
:deep(.v-btn__content) {
  gap: 10px;
}
.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(21, 101, 192, 0.12);
  color: #1565C0;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.user-name {
  font-size: 0.85rem;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dropdown */
.user-dropdown {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  padding: 6px;
  overflow: hidden;
}
.dropdown-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px 10px;
}
.dropdown-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(21, 101, 192, 0.12);
  color: #1565C0;
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dropdown-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}
.dropdown-email {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 1px;
}
.dropdown-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.07);
  margin: 4px 0;
}
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border-radius: 7px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
  transition: background 0.1s ease;
  text-align: left;
}
.dropdown-item:hover {
  background: #f1f5f9;
}
.dropdown-item--danger {
  color: #dc2626;
}
.dropdown-item--danger:hover {
  background: rgba(220, 38, 38, 0.06);
}
</style>
